import React, { Component } from 'react';
import { Form, Message } from 'semantic-ui-react';

class NonProfitInfo extends Component {

  render() {
    const { setRules, valid } = this.props;
    const rules = {
      "name": "required"
    };
    const customMessages = {
      "required.name": "Name is required"
    };
    setRules(rules, customMessages);
    return (
      <Form error={valid.errorCount > 0}>
        {valid.errorCount > 0 && <Message
          error
          content={Object.keys(valid.errors.all()).map((item, key) => {
            return (
              <span key={key}>
                {valid.errors.first(item)}
                <br />
              </span>
            );
          })}
        />}
        <Form.Field required>
          <label>Name of Non-profit:</label>
          <Form.Input
            placeholder='Name of Non-profit'
            name="name"
            value={this.props.profile.name}
            onChange={this.props.handleChange}
            required
            error={valid.errors.has("name")}
          />
        </Form.Field>
        <Form.Field>
          <label>Non-profit Fed Tax Id#:</label>
          <Form.Input
            placeholder='Non-profit Fed Tax Id'
            name="fed_tax_id"
            fluid
            value={this.props.profile.fed_tax_id || ""}
            onChange={this.props.handleChange}
          />
        </Form.Field>
        <h3>NON-PROFIT INFO</h3>
        <Form.Field>
          <label>Website:</label>
          <Form.Input
            placeholder='Website'
            onChange={this.props.handleChange}
          />
        </Form.Field>
        <Form.Field>
          <label>Address:</label>
          <Form.Input
            placeholder='Address'
            name="address"
            value={this.props.profile.address || ""}
            onChange={this.props.handleChange}
          />
        </Form.Field>
        <Form.Field>
          <label>Email Address:</label>
          <Form.Input
            type='email'
            name="email"
            placeholder='Email Address'
            value={this.props.profile.email || ""}
            onChange={this.props.handleChange}
          />
        </Form.Field>
        <Form.Field>
          <label>Telephone Number:</label>
          <Form.Input
            placeholder='Telephone Number'
            name="phone_number"
            value={this.props.profile.phone_number || ""}
            onChange={this.props.handleChange}
            onBlur={this.props.handlePhoneNumber}
          />
        </Form.Field>
        <Form.Field>
          <label>Fax Number:</label>
          <Form.Input
            placeholder='Fax Number'
            name="fax_number"
            value={this.props.profile.fax_number || ""}
            onChange={this.props.handleChange}
          />
        </Form.Field>
        <Form.Button
          type="button"
          primary
          size="large"
          content="Save And Continue"
          floated="right"
          onClick={() => this.props.handleStep("contact-info")}
        />
      </Form>
    )
  }
}

export default NonProfitInfo;